<template>
  <div class="employDetail">
    <el-tabs v-model="curDetail" class="el-tabs-card" @tab-click="handleClick">
      <el-tab-pane label="基础信息" name="base">
        <el-form
          :model="formData"
          label-width="125px"
          :inline="true"
          label-position="right"
          class="form-horizontal detail-form detail-text-form"
        >
          <div class="font-18 m-b-16">经营者信息</div>
          <el-row class="detail-box">
            <el-col :span="12">
              <el-form-item class="w-p-100" label="经营者：">
                {{ formData.realManagerName }}
              </el-form-item>
              <el-form-item class="w-p-100" label="经营类别：">
                {{ formData.manageTypeName }}
              </el-form-item>
              <el-form-item v-if="!isButler" class="w-p-100" label="联系电话：">
                {{ formData.realManagerPhone }}
              </el-form-item>
              <el-form-item class="w-p-100" label="证件种类：">
                {{ formData.realManagerCertTypeName }}
              </el-form-item>
              <el-form-item class="w-p-100" label="申报日期：">
                {{ formData.createTime }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="w-p-100" label="经营者编码：">
                {{ formData.managerCode }}
              </el-form-item>

              <el-form-item class="w-p-100" label="门店数：">
                {{ formData.storeCount }}
              </el-form-item>

              <el-form-item class="w-p-100" label="房源数：">
                {{ formData.roomCount }}
              </el-form-item>

              <el-form-item v-if="!isButler" class="w-p-100" label="证件号码：">
                {{ formData.realManagerCertCode }}
              </el-form-item>

              <el-form-item class="w-p-100" label="更新时间：">
                {{ formData.updateTime }}
              </el-form-item>
            </el-col>
          </el-row>

          <div class="font-18 m-b-16 m-t-16" v-show="isShowCompany">单位信息</div>
          <el-row class="detail-box" v-show="isShowCompany">
            <el-col :span="12">
              <el-form-item class="w-p-100" label="经营单位：">
                {{ formData.companyName }}
              </el-form-item>
              <el-form-item class="w-p-100" label="单位联系电话：">
                {{ formData.companyPhone }}
              </el-form-item>
              <el-form-item class="w-p-100" label="法人联系电话：">
                {{ formData.corporationPhone }}
              </el-form-item>
              <el-form-item class="w-p-100" label="法人外文姓名：">
                {{
                  formData.corporationFirstName +
                  " " +
                  formData.corporationLastName
                }}
              </el-form-item>
              <el-form-item class="w-p-100" label="法人证件号码：">
                {{ formData.corporationCertCode }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="w-p-100" label="社会信用代码：">
                {{ formData.companyCreditCode }}
              </el-form-item>

              <el-form-item class="w-p-100" label="法人：">
                {{ formData.corporationName }}
              </el-form-item>

              <el-form-item class="w-p-100" label="法人国籍：">
                {{ formData.realManagerCountryName }}
              </el-form-item>

              <el-form-item class="w-p-100" label="法人证件种类：">
                {{ formData.corporationCertTypeName }}
              </el-form-item>

              <el-form-item class="w-p-100" label="法人实际居住地：">
                {{ formData.corporationAddr }}
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-collapse v-model="activeNames">
        <el-collapse-item title="经营者信息" name="1">
          <div class="detail-box">
            <el-form-item class="sp-width-50" label="来源平台：">
              {{ formData.allPlatName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="经营者编码：">
              {{ formData.managerCode }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="申报日期：">
              {{ formData.createTime }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="更新时间：">
              {{ formData.updateTime }}
            </el-form-item>
          </div>
        </el-collapse-item>
        <el-collapse-item title="单位信息" name="2">
          <div class="detail-box">
            <el-form-item class="sp-width-50" label="经营人：">
              {{ formData.realManagerName }}
            </el-form-item>
            <el-form-item v-if="!isButler" class="sp-width-50" label="联系电话：">
              {{ formData.realManagerPhone }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="国籍：">
              {{ formData.realManagerCountryName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="外文姓名：">
              {{ formData.realManagerFirstName + ' ' + formData.realManagerLastName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="证件种类：">
              {{ formData.realManagerCertTypeName }}
            </el-form-item>
            <el-form-item v-if="!isButler" class="sp-width-50" label="证件号码：">
              {{ formData.realManagerCertCode }}
            </el-form-item>
            <el-form-item class="sp-width-100" label="实际居住地：">
              {{ formData.realManagerAddr }}
            </el-form-item>
          </div>
        </el-collapse-item>
        <el-collapse-item title="经营单位信息" name="3" v-show="isShowCompany">
          <div class="detail-box">
            <el-form-item class="sp-width-100" label="经营单位：">
              {{ formData.companyName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="社会信用代码：">
              {{ formData.companyCreditCode }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="单位联系电话：">
              {{ formData.companyPhone }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人：">
              {{ formData.corporationName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人联系电话：">
              {{ formData.corporationPhone }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人国籍：">
              {{ formData.realManagerCountryName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人外文姓名：">
              {{ formData.corporationFirstName + ' ' + formData.corporationLastName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人证件种类：">
              {{ formData.corporationCertTypeName }}
            </el-form-item>
            <el-form-item class="sp-width-50" label="法人证件号码：">
              {{ formData.corporationCertCode }}
            </el-form-item>
            <el-form-item class="sp-width-100" label="法人实际居住地：">
              {{ formData.corporationAddr }}
            </el-form-item>
          </div>
        </el-collapse-item>
      </el-collapse> -->
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="审核记录" name="check">
        <AuditLog class="detail-container" :detail-data="oriResult" />
      </el-tab-pane>
      <el-tab-pane label="变更记录" name="update">
        <UpdateLog class="detail-container" :detail-data="oriResult" />
      </el-tab-pane>
    </el-tabs>

    <div class="footer-btn m-t-15 align-r">
      <el-button class="cancel-btn" @click="handleCancel">关闭</el-button>
    </div>
  </div>
</template>

<script>
import AuditLog from './components/auditLog.vue'
import UpdateLog from './components/updateLog.vue'

import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
export default {
  name: 'employeeDetail',
  mixins: [tableMix],
  components: { RTable, AuditLog, UpdateLog },
  emits: ['closeModel'],
  props: {
    detailModal: { type: Boolean, default: false },
    detailData: { type: Object, default: () => ({ id: '$%&' }) },
    isEncry: { type: Boolean, default: true },
    encryList: { type: Object, default: () => ({}) },
    encryFunc: { type: Function, default: () => { } }
  },
  data() {
    let detailKeys = [
      'allPlatName',
      'managerCode',
      'manageTypeName',
      'storeCount',
      'roomCount',
      'createTime',
      'updateTime',
      'realManagerName',
      'realManagerPhone',
      'realManagerCountryName',
      'realManagerFirstName',
      'realManagerLastName',
      'realManagerCertTypeName',
      'realManagerCertCode',
      'realManagerAddr',
      'companyName',
      'companyCreditCode',
      'companyPhone',
      'corporationName',
      'corporationPhone',
      'realManagerCountryName',
      'corporationFirstName',
      'corporationLastName',
      'corporationCertTypeName',
      'corporationCertCode',
      'corporationAddr'
    ]
    let formData = {}
    detailKeys.map((key) => {
      formData[key] = ''
    })
    return {
      curDetail: 'base', // 当前展示的详情
      isShowCompany: false,

      userInfo: {},
      activeNames: ['0', '1', '2', '3', '4', '5', '6'],
      formData,
      oriResult: {}, // 接口返回的完整数据
    }
  },
  created() {
    this.curDetail = 'base'
    this.getDetail()

    this.userInfo = localStorage.getItem('user')
    this.userInfo = this.userInfo ? JSON.parse(this.userInfo) : {}
  },
  computed: {
    // 是否管家
    isButler() {
      if (this.userInfo.userType == 3) return true
      return false
    },
  },
  watch: {
    detailModal(val) {
      if (val === false) {
        return false
      }
      this.curDetail = 'base'
      this.getDetail()
    },
  },
  methods: {
    // 获取详情
    getDetail() {
      let params = {
        id: this.detailData.id
      };
      let url = "MANAGER.GET_DETAIL";
      this.fetchData({ url, method: "get", params }).then(res => {
        res = res || {}
        this.oriResult = res
        this.buildFormData(res)
      })
    },
    // 构建详情
    buildFormData(data) {
      this.formData = Object.assign(this.formData, data)

      if (this.isEncry) {
        for (let key in this.encryList) {
          for (let formKey in this.formData) {
            if (key === formKey) {
              this.formData[formKey] = this.encryFunc(this.formData[formKey], this.encryList[key])
            }
          }
        }
      }

      for (let key in this.formData) {
        if (this.formData[key] === '' || this.formData[key] == null) {
          this.formData[key] = '--'
        }
      }

      this.isShowCompany = false
      if (this.detailData.manageType == 2) {
        this.isShowCompany = true
      }
    },
    // 处理详情切换
    handleChangeDetail(type) {
      this.curDetail = type
    },
    handleCancel() {
      this.$emit('closeModel')
    },
  },
}
</script>

<style lang="less" scoped>
.detail-box {
  background-color: #f5f5f5;
  padding: 18px 30px;
  border-radius: 3px;
}
.el-form-item--default{
  margin-bottom: 0;
  /deep/ .el-form-item__label{
    font-weight:normal;
    color: #959697;
  }
  /deep/ .el-form-item__content{
    color: #333333;
  }
}
</style>